import React, { useState } from "react";
import {
  Flex,
  Input,
  Dropdown,
  Text,
  Label,
} from "@fluentui/react-northstar";

const COMMENT_TAGS = [
  { key: "positive", value: "Positive", color: "#92C353" },
  { key: "suggestion", value: "Suggestion", color: "#F8D347" },
  { key: "issue", value: "Issue", color: "#E2726E" },
  { key: "grammar", value: "Grammar", color: "#8B9DC3" },
  { key: "structure", value: "Structure", color: "#6264A7" },
  { key: "citation", value: "Citation", color: "#FF8C00" },
];

const CommentInput = ({ comment, setComment, selectedTag, setSelectedTag, disabled }) => {

  const tagOptions = COMMENT_TAGS.map((tag) => ({
    content: (
      <Flex vAlign="center" gap="gap.small">
        <Label
          circular
          styles={{
            backgroundColor: `${tag.color}20`,
            color: tag.color,
          }}
          content={tag.value}
        />
      </Flex>
    ),
    key: tag.key,
    value: tag.value,
  }));

  return (
    <Flex column gap="gap.small">
      <Flex column gap="gap.smaller">
        <Text size="small" weight="semibold">
          Tag
        </Text>
        <Dropdown
          items={tagOptions}
          placeholder="Select tag"
          value={selectedTag.value}
          getA11ySelectionMessage={(item) => `${item.value} has been selected`}
          onChange={(e, { value }) => {
            const tag = COMMENT_TAGS.find((t) => t.value === value.value);
            if (tag) {
              setSelectedTag(tag);
            }
          }}
          disabled={disabled}
          fluid
          styles={{
            maxWidth: "200px",
          }}
        />
        <Text size="small" weight="semibold">
          Add Comment
        </Text>
        <Input
          placeholder="Type your comment here..."
          value={comment}
          onChange={(e, { value }) => setComment(value)}
          disabled={disabled}
          fluid
          input={{
            "data-cy": "comment-input",
          }}
        />
      </Flex>
    </Flex>
  );
};

export default CommentInput;
